/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Download_InvoiceInputs */

const vi_invoice_download_invoice = /** @type {(inputs: Invoice_Download_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hóa đơn`)
};

/**

* @param {Invoice_Download_InvoiceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_download_invoice = /** @type {((inputs?: Invoice_Download_InvoiceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Download_InvoiceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_download_invoice(inputs)
});